// extracted by css-extract-rspack-plugin
export default {"idle":"Idle-module__idle__N6xDBuO","copilotRun":"Idle-module__copilotRun__GCwsoOJ"};